import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useStep1 from "./useStep1";
import {
  FormCheckbox,
  FormInput,
  FormPhoneInput,
  FormSelect,
  Loader,
} from "@/components";
import {
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  COMMUNITY_ID,
  CONTACT_NAME,
  EMAIL_ID,
  FEIN,
  IS_ACTIVE,
  NAME,
  PHONE_NO,
  STATE,
  WEBSITE,
  ZIPCODE,
} from "./consts";
import { FC } from "react";
import { StepsProps } from "../../types";

const Step1: FC<StepsProps> = ({ onCancel, onNextClick }) => {
  const {
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    isUpdatePending,
    isView,
    stateList,
    stateKey,
    isVendorDtlLoading,
    vendorId,
    formatFein,
  } = useStep1({ onNextClick });
  const { errors } = form.formState;

  return (
    <>
      {isVendorDtlLoading ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                <FormInput
                  name={COMMUNITY_ID}
                  control={form.control}
                  label="Community ID"
                  placeholder="Please enter"
                  error={errors[COMMUNITY_ID]?.message}
                  isRequired={requiredFields.includes(COMMUNITY_ID)}
                  disabled
                />
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Vendor Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled={isView}
                />
                <FormInput
                  name={CONTACT_NAME}
                  control={form.control}
                  label="Contact Name"
                  placeholder="Please enter"
                  error={errors[CONTACT_NAME]?.message}
                  isRequired={requiredFields.includes(CONTACT_NAME)}
                  disabled={isView}
                />
                <FormInput
                  name={FEIN}
                  control={form.control}
                  label="FEIN"
                  placeholder="Please enter"
                  error={errors[FEIN]?.message}
                  // isRequired={requiredFields.includes(FEIN)}
                  disabled={isView}
                  variant="integer"
                  format={formatFein}
                />
                <FormPhoneInput
                  name={PHONE_NO}
                  control={form.control}
                  label="Phone No."
                  placeholder="Please enter"
                  error={errors[PHONE_NO]?.message}
                  isRequired={requiredFields.includes(PHONE_NO)}
                  disabled={isView}
                />
                <FormInput
                  name={EMAIL_ID}
                  control={form.control}
                  label="Email ID"
                  placeholder="Please enter"
                  error={errors[EMAIL_ID]?.message}
                  isRequired={requiredFields.includes(EMAIL_ID)}
                  disabled={isView}
                />
                <FormInput
                  name={WEBSITE}
                  control={form.control}
                  label="Website"
                  placeholder="Please enter"
                  error={errors[WEBSITE]?.message}
                  isRequired={requiredFields.includes(WEBSITE)}
                  disabled={isView}
                />
                <FormInput
                  name={ADDRESS_1}
                  control={form.control}
                  label="Address 1"
                  placeholder="Please enter"
                  error={(errors as any)[`${ADDRESS_1}`]?.message}
                  isRequired={requiredFields.includes(ADDRESS_1)}
                  disabled={isView}
                />
                <FormInput
                  name={ADDRESS_2}
                  control={form.control}
                  label="Address 2"
                  placeholder="Please enter"
                  error={(errors as any)[`${ADDRESS_2}`]?.message}
                  isRequired={requiredFields.includes(ADDRESS_2)}
                  disabled={isView}
                />
                <FormSelect
                  key={stateKey}
                  name={STATE}
                  control={form.control}
                  label="State"
                  placeholder="Please select"
                  error={(errors as any)[`${STATE}`]?.message}
                  isRequired={requiredFields.includes(STATE)}
                  options={stateList?.map((data: any) => ({
                    label: data.name,
                    value: data.code,
                  }))}
                  disabled={isView}
                />
                <FormInput
                  name={CITY}
                  control={form.control}
                  label="City"
                  placeholder="Please enter"
                  error={(errors as any)[`${CITY}`]?.message}
                  isRequired={requiredFields.includes(CITY)}
                  disabled={isView}
                  variant="char"
                />
                <FormInput
                  name={ZIPCODE}
                  control={form.control}
                  label="Zipcode"
                  placeholder="Please enter"
                  error={(errors as any)[`${ZIPCODE}`]?.message}
                  isRequired={requiredFields.includes(ZIPCODE)}
                  maxLength={10}
                  minLength={10}
                  disabled={isView}
                  variant="integerSpeChar"
                />
                {vendorId && (
                  <FormCheckbox
                    name={IS_ACTIVE}
                    control={form.control}
                    label="Is Active?"
                    error={errors[IS_ACTIVE]?.message}
                    isRequired={requiredFields.includes(IS_ACTIVE)}
                    disabled={isView}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3  py-3">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isAddPending || isUpdatePending}
              >
                Cancel
              </Button>
              {!isView && (
                <Button
                  type="submit"
                  disabled={isAddPending || isUpdatePending}
                >
                  {isAddPending || isUpdatePending ? (
                    <Loader variant="secondary" />
                  ) : (
                    <></>
                  )}{" "}
                  Save & Next
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      )}
    </>
  );
};

export default Step1;
